"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAnalyticsHeader = void 0;
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const switch_1 = require("client/components/material/switch");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./order-analytics-header.less");
let OrderAnalyticsHeader = class OrderAnalyticsHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.filterDate = "";
        this.siteId = 0;
        this.startDate = "";
        this.endDate = "";
        this.distributor = "";
        this.ndcValue = "";
        this.showDisabledSites = false;
        this.headerToggle = (submit = false) => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
            if (!submit) {
                if (this.showDisabledSites) {
                    this.showDisabledSites = false;
                }
            }
        };
        this.handleLoader = () => {
            store_1.reportsStore.showLoader = !store_1.reportsStore.showLoader;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleChangeDistributor = (value) => {
            this.distributor = value;
        };
        this.handleShowDisabledSitesToggle = () => {
            this.showDisabledSites = !this.showDisabledSites;
        };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle(true);
            await store_1.reportsStore.loadOrderAnalytics(this.distributor, this.ndcValue, this.startDate, this.endDate, this.siteId, this.showDisabledSites, true);
        };
        this.handleNdcChange = (e) => {
            const inputValue = e.target.value;
            const inputLength = inputValue.length;
            if (inputLength > 11) {
                return;
            }
            this.ndcValue = inputValue;
        };
        // Too lazy to figure out how to determine  which is which based on e.target.
        // So just rewrote pretty much the same functions for the date picker buttons
        // but for the individual start and end dates.
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleCancel = () => {
            store_1.reportsStore.editModal = !store_1.reportsStore.editModal;
            if (this.showDisabledSites) {
                this.showDisabledSites = false;
            }
        };
    }
    componentWillMount() {
        if (store_3.usersStore.user.value &&
            store_3.usersStore.user.value.siteUser &&
            store_3.usersStore.user.value.siteId) {
            this.siteId = store_3.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            store_2.sitesListStore.loadSitesNoRelation();
        }
    }
    componentDidMount() {
        store_1.reportsStore.getDistributors();
    }
    get availableOptions() {
        var _a, _b, _c;
        const options = store_1.reportsStore.distributors
            ? store_1.reportsStore.distributors.map((dist, i) => ({
                id: i,
                label: dist.label,
                value: dist.value
            }))
            : [];
        const optionAll = {
            id: -1,
            label: "All distributors",
            value: ""
        };
        // D-011
        if (!((_a = store_3.usersStore.user.value) === null || _a === void 0 ? void 0 : _a.distAdmin) && !((_b = store_3.usersStore.user.value) === null || _b === void 0 ? void 0 : _b.distManager) && !((_c = store_3.usersStore.user.value) === null || _c === void 0 ? void 0 : _c.distUser)) {
            options.unshift(optionAll);
        }
        return options;
    }
    render() {
        const { label = "Search", title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        const permissionToViewDisabledSites = store_3.usersStore.permissions.ViewDisabledSites;
        return (React.createElement("div", null,
            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                title && (React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                    React.createElement("div", { className: "filter-bar__title-text" }, title))),
                React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options")),
            store_1.reportsStore.editModal ? (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "fit-content", top: "20%", width: "fit-content", buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", null,
                        permissionToViewDisabledSites ? (React.createElement("div", { className: "sites__data__disabled-toggle" },
                            React.createElement(switch_1.MaterialSwitch, { label: "Show disabled sites", value: "showDisabledSites", checked: this.showDisabledSites, onChange: this.handleShowDisabledSitesToggle }))) : null,
                        React.createElement("br", null),
                        React.createElement("p", null, "NDCs must be 11 digits in length without spaces and without dashes (Defaults to all NDCs)."),
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, label: "Distributor", onSelect: this.handleChangeDistributor, value: String(this.distributor) || "", width: "100%" }),
                            React.createElement(text_field_1.MaterialTextField, { className: "product-search-field", label: "NDC", value: this.ndcValue, onChange: e => this.handleNdcChange(e), style: { marginLeft: "1em" } })),
                        React.createElement("div", { style: { display: "flex" } },
                            withDatePicker && (React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                                React.createElement("h3", null, "Start Date: "),
                                React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart, style: { marginRight: "1em" } }, "Today"),
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear")))),
                            withDatePicker && (React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                                React.createElement("h3", null, "End Date: "),
                                React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                                React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd, style: { marginRight: "1em" } }, "Today"),
                                    React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear"))))))))) : null,
            store_1.reportsStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null));
    }
};
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "distributor", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "ndcValue", void 0);
__decorate([
    mobx_1.observable
], OrderAnalyticsHeader.prototype, "showDisabledSites", void 0);
__decorate([
    mobx_1.computed
], OrderAnalyticsHeader.prototype, "availableOptions", null);
OrderAnalyticsHeader = __decorate([
    mobx_react_1.observer
], OrderAnalyticsHeader);
exports.OrderAnalyticsHeader = OrderAnalyticsHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/order-analytics/components/order-analytics-header.tsx
// module id = 3926
// module chunks = 0